export default {
  namespaced: true,
  service_orders: {
    title: "Service orders",
    reference_number: "Reference number",
    company: "Company",
    facility: "Facility",
    attention_date: "Attention date",
    date_filters: "Date filters",
    status: "status",
    status_change_date: "status change date",
    delete_selection: "delete selection",
    required_fields_to_filter_by_date: "Required fields to filter by date",
    pending: "Pending",
    in_review: "In review",
    in_progress: "In progress",
    finished: "Finalized",
    canceled: "Canceled",
    show_maintenance_form: 'Show maintenance form'
  },
};
